// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qa-2";
export var chatLink = "_qa-0";
export var chatText = "_qa-1";